import React from 'react';
import Location from '../../Profile/Location/';
import './CardSedes.scss'

const CardSedes = ({ authClient }) => {
    const sede = authClient.sede;
    return (
        <>
            <section className="containerMain">
                <p className="containerMain_title">Sedes</p>
                {sede && sede ? (sede.map((item, index) => (
                    <div className="containerMain_item">
                        <Location key={index} elements={item} id={index} preview={true} />
                    </div>
                ))) : (null)}
            </section>

        </>
    );
}

export default CardSedes;